// Handles multiple checkboxes
import {get, keys, startCase, mapValues, map} from 'lodash'
import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import * as Actions from '../redux/actions'
import { kvReplace } from '../lib/utils'

const kvReplaceToken = ['{', '}']

class SelectCheckbox extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id      : this.props.id,
      schema  : this.props.schema,
      classes : get(this, 'props.AXGClasses.select-checkbox', 'form-group'),
      value   : '',
      values  : {},
      checked : false,
      data    : get(this, 'props.schema.data.fallback',
                  [ {value: 'loading', text: 'Loading ...'} ]),
      updates: get(this.props.schema, 'updates', ''),
    }
  }

  handleCheckboxClick(e) {
    var component = this
    // var value = e.target.value
    // toggle
    var checked = e.target.checked
    var id = e.target.id
    // console.log(`checked / value: ${checked} / ${value}`)
    var values = this.state.values
    values[id] = checked
    // console.log(`values: ${JSON.stringify(values)}`)
    this.setState(values)
    // console.log(`Redux Update: ${this.props.AXGKey}`);
    console.info(`Redux Update: ${id}`)
    this.props.actions.setAppxigonState({
      key   : id,
      value : checked,
    })
    if (component.state.updates) {
      console.log(`Update dependency for: ${component.state.updates}`)
      component.props.actions.setAppxigonState({
        key : `dependency.${component.state.updates}`,
        // make it a string. value not important, used to change a redux value to trigger update
        value: JSON.stringify(`${component.state.id}.${id}.${checked}`),
      })
    }
  }

  componentWillMount() {
    this.refreshData()
  }

  // TODO: extract refreshData with other components such as Select
  refreshData() {
    // TODO: handle data direct source URL from component
    var component = this
    var schema = this.state.schema
    var dataSourceDef = get(schema, 'data.source') // e.g. 'ref.users' => 'data.ref.users'
    // console.log(dataSourceDef);
    var refDataSource = get(this.props.AXGDataSource, `${dataSourceDef}.source`, null)
    var refDataTransform = get(this.props.AXGDataSource, `${dataSourceDef}.transform`, null)
    var refDataFallback = get(this.props.AXGDataSource, `${dataSourceDef}.fallback`, null)
    // console.log(refDataSource);
    // console.log(refDataTransform);
    if (refDataSource) {
      var data = []
      // var dataTransform = refDataDef.transform
      // REVIEW: more generic way to handle GET variables transform
      var endpoint = refDataSource.endpoint
      var endpointTransform = get(refDataSource, 'transform')
      if (endpointTransform) {
        let keyMap = endpointTransform
        let keyMapTransformed =
          mapValues(
            keyMap,
            (val)=> {
              return get(component.props, ['input', `${val}`])
            }
          )
        console.log(`keyMap: ${JSON.stringify(keyMap)}`)
        console.log(`keyMapTransformed: ${JSON.stringify(keyMapTransformed)}`)
        endpoint = kvReplace(
          endpoint,
          keyMapTransformed,
          kvReplaceToken
        )
      }
      console.info(`AJAX endpoint: ${JSON.stringify(endpoint)}`)
      $.ajax({
        url: endpoint,
        method: 'GET'
      }).then(function(rawData) {
        // console.log(`rawData: ${JSON.stringify(rawData)}`)
        if (refDataTransform) {
          var keyMap = refDataTransform
          data = map(rawData, (item, key)=> {
            return mapValues(keyMap, (val)=> {
              return keys(item).includes(val)
                      ? item[val]
                      : kvReplace(val, item, kvReplaceToken)
            })
          })
          // console.log(`transformed data: ${JSON.stringify(data)}`)
        } else {
          data = rawData
        }
        component.setState({
          data  : data
        })
      })
      // TODO: handle ajax call failure
      // this.setState({
      //   data  : [ { value: 'error', text: 'Unable to load data ...' } ],
      // })
    } else {
      // handle direct source link from within item
      if (refDataFallback) {
        component.setState({
          data  : refDataFallback,
        })
      }
    }
    // Set current or default value
    var storeKey = component.props.AXGKey // default storeKey
    var localStoreKey = get(component.state.schema, 'store-key', null)
    if (localStoreKey) {
      var l = storeKey.split('.')
      l.pop() // remove last element from array
      l.push(localStoreKey)
      storeKey = l.join('.')
    }
    var currentValue = get(component.props.appxigonState, storeKey, '')
    console.log(`currentValue: ${currentValue}`)
    component.setState({
      value: currentValue,
    })
  }

  componentWillReceiveProps(nextProps) {
    var component = this
    // REVIEW: is this a proper way ? Will this trigger unnecessary update?
    var dependencyKey = `dependency.${this.props.AXGKey}`
    var nextDepencyValue = get(nextProps.appxigonState, dependencyKey, '')
    if (this.state.dependency != nextDepencyValue) {
      console.info(`select: (${component.state.id}) dependency changed: refreshData`)
      this.refreshData()
    }
    this.setState({
      dependency: nextDepencyValue,
    })
  }

  render() {
    var schema = this.state.schema
    var id = `select-${this.state.id}`
    var title = get(schema, 'title', startCase(this.state.id))
    var icon = get(schema, 'icon', null)

    // TODO: option of inline (wrap each with 'checkbox' class)
    // or new line checkboxes (as it is now)
    return (
      <div className={`${this.state.classes}${this.props.show ? '' : ' hidden'}`}>
        <div className='input-group'>
          <span class="input-group-addon">
            <i className="material-icons">{ icon }</i>
          </span>
          <label htmlFor={id}>{title}</label>
          <div className='checkbox'>
          {
            this.state.data.map(
              (i) => {
                let checkboxID = `${this.props.AXGKey}.${i.value}`
                return <label key={i.value}>
                          <input
                            type='checkbox'
                            id={checkboxID}
                            name={checkboxID}
                            value={i.value}
                            checked={this.state[checkboxID]}
                            onClick={this.handleCheckboxClick.bind(this)}/>
                              &nbsp;
                              {i.text}
                              &nbsp;
                        </label>
              }
            )
          }
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    appxigonState: state.AXGState,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectCheckbox)



// WEBPACK FOOTER //
// ./item-types/select-checkbox.js